<script>
  import {getContext, onMount} from 'svelte';
  import {combineLatest} from 'rxjs';
  import {filter, map, startWith} from 'rxjs/operators';
  import {stringify} from 'query-string';
  import {goto, stores} from '@sapper/app';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {LINKS} from '@/const/link';
  import {envUtil} from '@/helper/env';
  import {userInfo$} from '@/store/user';
  import {fixLink$} from '@/store/lang';
  import {IMAGES} from '../images';
  import lang from '../ReferralEntryPage.lang';
  import {depositStatus$, kycInfo$, query$} from '../streams';
  import {userStatus$} from '@/streams/auth';

  export let inviteeRewards = '0';
  export let limitDay = 30;

  const LG = getContext('LG');
  const {page} = stores();
  const StepPath = {
    Trade: LINKS.PHEMEX_CONTRACT_TRADE + '/BTC-USDT',
    Kyc: '/rewards-hub',
    Deposit: PATHS.ASSETS_DEPOSIT.pathname,
    REGISTER: PATHS.REGISTER.pathname,
  };
  let rewards = '0';
  let day = 0;
  let steps$ = genSteps('', {}, false, inviteeRewards, limitDay);
  $: updateData($userStatus$, $kycInfo$, $depositStatus$, inviteeRewards, limitDay);

  function updateData(userStatus, kycInfo, depositStatus, inviteeRewards, limitDay) {
    steps$ = genSteps(userStatus !== 'Login', kycInfo.advanceKycStatus === 'Verified', depositStatus, inviteeRewards, limitDay);
  }

  onMount(() => {
    query$.next();
  });

  function genSteps(isLogin, isAdvanceKyc, isDeposit, rewards, limitDay) {
    return combineLatest([userInfo$]).pipe(
      filter(([info]) => info.userId),
      map(([info]) => {
        return [genStepFirst(isLogin, info.referralCode), genStepSecond({isLogin, isAdvanceKyc, isDeposit}, limitDay), genStepThird({isLogin, isAdvanceKyc, isDeposit}, rewards, limitDay)];
      }),
      startWith([genStepFirst(isLogin, $page.query?.referralCode), genStepSecond({isLogin, isAdvanceKyc, isDeposit}, limitDay), genStepThird({isLogin, isAdvanceKyc, isDeposit}, rewards, limitDay)])
    );
  }

  function genStepFirst(isLogin, referralCode) {
    return {
      img: "https://static.phemex.com/pubimg/60ffc93e248e45dac8308d66a7ff1874b05bd91b62a460644e3de180ab2943f1.png",
      title: LG(lang.Step1Title),
      desc: LG(lang.Step1Desc),
      btnText: !isLogin ? LG(lang.Step1CompleteBtn) : LG(lang.Step1Btn),
      disabled: !isLogin,
      handle() {
        goto($fixLink$(StepPath.REGISTER) + '?' + stringify({referralCode, target: location.href, action: 'Target'}));
      },
    };
  }

  function genStepSecond({isLogin, isAdvanceKyc, isDeposit}, limitDay) {
    return {
      img: "https://img.phemex.com/v1/bf3b5e79-2b23-44f5-8162-6c317a3f5f99/verify-and-deposit.png",
      title: LG(lang.Step2Title),
      desc: LG(lang.Step2Desc, {LimitDay: limitDay}),
      btnText: isAdvanceKyc ? LG(lang.Step2Btn) : LG(lang.Step2KycBtn),
      disabled: !isLogin ? isAdvanceKyc && isDeposit : true,
      handle() {
        gotoUrl($fixLink$(isAdvanceKyc ? StepPath.Deposit : StepPath.Kyc));
      },
    };
  }

  function genStepThird({isLogin, isAdvanceKyc, isDeposit}, rewards, limitDay) {
    return {
      img: "https://img.phemex.com/v1/43625f9b-a29a-4d16-b88a-353c6b84395e/trade-to-earn.png",
      title: LG(lang.Step3Title),
      desc: LG(lang.Step3Desc, {LimitDay: limitDay, Value: `${'$' + rewards}`}),
      btnText: LG(lang.Step3Btn),
      disabled: !(!isLogin && isAdvanceKyc && isDeposit),
      handle() {
        gotoUrl($fixLink$(StepPath.Trade));
      },
    };
  }

  function gotoUrl(url) {
    if (envUtil.isApp) {
      goto(url);
      return;
    }
    window.open(url);
  }
</script>

<style>
  .steps {
    margin: 40px auto 0;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 32px 0;
    width: 1200px;
    font-family: Gilroy;
  }
  .step {
    width: 300px;
    font-size: 0;
    color: #000;
  }
  .step > span {
    display: inline-block;
    width: 120px;
    height: 120px;
  }
  .step > span img {
    width: inherit;
    height: inherit;
  }
  .step > span {
    display: inline-block;
    width: 120px;
    height: 120px;
  }
  .step > span img {
    width: inherit;
    height: inherit;
  }
  .title {
    padding: 24px 0;
    line-height: 28px;
    font-family: Gilroy;
    color: #1d2129;
  }
  .desc {
    padding-bottom: 24px;
    height: 60px;
    color: rgba(29, 33, 41, 0.85);
  }
  .pc {
    display: block;
  }
  .arrow {
    margin-top: 116px;
  }
  .step :global(.medium) {
    border: 1px solid var(--blue);
    height: 52px;
  }
  .step :global(.ghost) {
    background-color: unset;
    color: var(--blue);
  }
  .step :global(.disabled) {
    border: unset;
    border: 1px solid #fff;
    background-color: rgba(0, 63, 230, 0.5);
    color: var(--B1);
    opacity: 1;
  }
  .step :global(.disabled:hover) {
    border-color: unset;
    background: rgba(0, 63, 230, 0.5);
  }
  .step :global(.step-btn) {
    color: #fff;
    border-radius: 26px;
    background: var(--blue-main);
    border-color: var(--blue-main);
    font-weight: bold;
    font-size: 20px;
  }
  .step :global(.step-btn.disabled) {
    color: #fff;
    border-radius: 26px;
    background: var(--blue-main);
    border-color: var(--blue-main);
    opacity: 0.3;
  }
  .btn-inner {
    width: 240px;
    line-height: 20px;
    font-weight: var(--fw3);
    font-size: 16px;
  }
  @media screen and (max-width: 640px) {
    .steps {
      display: block;
      margin-top: 0;
      padding: 0px 16px 24px 16px;
      width: 100%;
    }
    .pc {
      display: none;
    }
    .h5 {
      display: block;
    }
    .step {
      margin-top: 24px;
      padding: 0 16px;
      width: unset;
      text-align: left;
    }
    .step > span {
      width: 64px;
      height: 64px;
    }
    .step > span img {
      width: inherit;
      height: inherit;
    }
    .title {
      padding: 12px 0 4px 0;
      line-height: 20px;
      font-weight: var(--fw3);
      font-size: 16px;
      color: #1d2129;
    }
    .desc {
      padding-bottom: 12px;
      height: auto;
      line-height: 22px;
      font-weight: var(--fw2);
      font-size: 14px;
      color: rgba(29, 33, 41, 0.85);
    }
    .step :global(.medium) {
      width: 100%;
      height: 40px;
      font-size: 12px;
    }
    .btn-inner {
      width: 100%;
      font-size: 12px;
    }
  }
</style>

<div class="steps df aifs">
  {#each $steps$ as step, i}
    <div class="step tc">
      <span><img width="120" alt={step.name} src={step.img} /></span>
      <div class="title f20 lh28 fw3">{step.title}</div>
      <div class="f16 lh20 fw2 desc">{@html step.desc}</div>
      {#if i === 0}
        <Button class="step-btn" disabled={step.disabled} type={step.btnType || 'primary'} on:click={!step.disabled && step.handle}>
          <div class="btn-inner">{step.btnText}</div>
        </Button>
      {/if}
      {#if i === 1}
        <Button class="step-btn" disabled={step.disabled} type={step.btnType || 'primary'} on:click={!step.disabled && step.handle}>
          <div class="btn-inner">{step.btnText}</div>
        </Button>
      {/if}
      {#if i === 2}
        <Button class="step-btn" disabled={step.disabled} type={step.btnType || 'primary'} on:click={!step.disabled && step.handle}>
          <div class="btn-inner">{step.btnText}</div>
        </Button>
      {/if}
    </div>
    {#if i !== $steps$.length - 1}
      <img height="6" class="pc arrow" alt="Arrow" src="https://img.phemex.com/v1/4e1d8b0b-6132-4705-9695-4b2e51e516c3/line.png" />
    {/if}
  {/each}
</div>
